import { LayoutService } from './../layout/layout.service';
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';

@Component({
  selector: 'app-fixed-save-header',
  templateUrl: './fixed-save-header.component.html',
  styleUrls: ['./fixed-save-header.component.scss'],
  standalone: false
})
export class FixedSaveHeaderComponent {
  @Input() isLoading: boolean;
  @Input() isValid: boolean;
  @Input() showSave: boolean = true;
  @Input() showBack: boolean = false;

  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  get topOffset(): string {
    return this.layoutService.layoutHeightOffsetTop + 'px';
  }

  get sidenavWidth(): string {
    const sidenav = document.querySelector('.mat-sidenav');

    return (sidenav?.getBoundingClientRect().width || 0) + 'px';
  }

  constructor(private layoutService: LayoutService, @Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
